// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  organizationId: __t.string().name("organization_id"),
  userId: __t.string().name("user_id"),
  name: __t.string(),
  description: __t.option(__t.string()),
  icon: __t.option(__t.string()),
  category: __t.option(__t.string()),
  workflowName: __t.string().name("workflow_name"),
  nodes: __t.string(),
  connections: __t.string(),
  pinData: __t.option(__t.string()).name("pin_data"),
  author: __t.string(),
  executionType: __t.string().name("execution_type"),
  version: __t.string(),
  isActive: __t.bool().name("is_active"),
  isVisible: __t.bool().name("is_visible"),
  isOnHomeView: __t.bool().name("is_on_home_view"),
  requiresAccount: __t.bool().name("requires_account"),
  createdAt: __t.option(__t.timestamp()).name("created_at"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
});
